import { useRef, useEffect, ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface DropdownProps {
  trigger: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  /** Width class, e.g. 'w-48' or 'w-64' */
  width?: string;
  className?: string;
}

export default function Dropdown({ trigger, isOpen, onClose, children, width = 'w-48', className }: DropdownProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClose();
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen, onClose]);

  return (
    <div className="relative" ref={ref}>
      {trigger}
      {isOpen && (
        <div className={cn(
          'absolute right-0 mt-2 bg-card/95 backdrop-blur-xl border border-border rounded-xl shadow-2xl overflow-hidden z-50',
          width,
          className,
        )}>
          {children}
        </div>
      )}
    </div>
  );
}
